import {
  MissionAvailableIcon,
  NotificationFallbackIcon,
  ReminderAtTimeIcon,
  ReminderWhenAvailableIcon,
  WaitForIcon,
  WorkspaceInviteIcon,
} from './icons';

/**
 * Stored on inbox items as `type`. Add a row here when a new kind of
 * ping exists — the panel reads icon + prefix from this list only.
 */
export const NOTIFICATION_TYPE = {
  MISSION_AVAILABLE: 'mission_available',
  REMINDER_AT_TIME: 'reminder_at_time',
  REMINDER_WHEN_AVAILABLE: 'reminder_when_available',
  WAIT_FOR: 'wait_for',
  WORKSPACE_INVITE: 'workspace_invite',
};

/** @deprecated use NOTIFICATION_TYPE.MISSION_AVAILABLE */
export const INBOX_TYPE_AVAILABLE = NOTIFICATION_TYPE.MISSION_AVAILABLE;

const FALLBACK = {
  id: 'unknown',
  label: 'Notification',
  prefix: 'Notification:',
  Icon: NotificationFallbackIcon,
};

export const NOTIFICATION_TYPES = {
  [NOTIFICATION_TYPE.MISSION_AVAILABLE]: {
    id: NOTIFICATION_TYPE.MISSION_AVAILABLE,
    label: 'Now available',
    prefix: 'Now available:',
    Icon: MissionAvailableIcon,
    usesMissionIcon: true,
  },
  [NOTIFICATION_TYPE.REMINDER_AT_TIME]: {
    id: NOTIFICATION_TYPE.REMINDER_AT_TIME,
    label: 'Reminder',
    prefix: 'Reminder:',
    Icon: ReminderAtTimeIcon,
  },
  [NOTIFICATION_TYPE.REMINDER_WHEN_AVAILABLE]: {
    id: NOTIFICATION_TYPE.REMINDER_WHEN_AVAILABLE,
    label: 'Became available',
    prefix: 'This mission is available:',
    Icon: ReminderWhenAvailableIcon,
  },
  [NOTIFICATION_TYPE.WAIT_FOR]: {
    id: NOTIFICATION_TYPE.WAIT_FOR,
    label: 'Wait for',
    prefix: 'Wait for:',
    Icon: WaitForIcon,
    asksFulfillment: true,
  },
  [NOTIFICATION_TYPE.WORKSPACE_INVITE]: {
    id: NOTIFICATION_TYPE.WORKSPACE_INVITE,
    label: 'Invite',
    prefix: 'You were invited to',
    Icon: WorkspaceInviteIcon,
    isInvite: true,
  },
};

export function getNotificationType(type) {
  return NOTIFICATION_TYPES[type] || FALLBACK;
}

export function isKnownNotificationType(type) {
  return Boolean(NOTIFICATION_TYPES[type]);
}
